<template>
  <div>
    <v-dialog v-if="eventLogDetailViewIO" :value="true" @input="eventLogDetailViewIO = false" v-model="eventLogDetailViewIO" class="" permanent fullscreen>
      <EventLogDetailViewIO
        v-if="selectedStep"
        :step="selectedStep"
        @closeIOView="$root.$emit('set-modal-open', false); eventLogDetailViewIO = false"
      />
    </v-dialog>
    <portal to="right-hand-nav-drawer">
      <div
        :key="key"
        v-if="eventLogSelectedEvent && showDialog"
        class="event-log-detail-view"
        :class="backgroundColour"
      >
        <div class="event-log-detail-view__header">
          <apio-button
            class="event-log-detail-view__header--close-button"
            button-size="small"
            button-type="get-started"
            @click.native="showDialog = false"
            >Close
            <apio-icon
              class="ml-2"
              size="16"
              name="cross"
              lightModeColour="white"
              darkModeColour="white"
          /></apio-button>
          <div class="event-log-detail-view__header--id h2 white--text">
            ID: {{ eventLogSelectedEvent.ref }}
          </div>
        </div>
        <div class="event-log-detail-view__inner">
          <div class="ma-6">
            <pre class="smalltext">{{ eventLogSelectedEvent.desc }}</pre>
          </div>
          <v-text-field
              v-on="on"
              v-model="q"
              placeholder="Search"
              dense
              outlined
              hide-details="auto"
              class="m-0 build__filter"
              @input="loadDetails()"
            ><template v-slot:append><apio-icon name="ui-search" /></template>
            </v-text-field>
          <div class="event-log-detail-view__statuses--title p2-extra-bold">
            Filter status
          </div>
          <div class="event-log-detail-view__statuses">
            <apio-checkbox :value="false" :checked="success" v-model="success"
              ><div
                class="event-log-detail-view__checkbox"
                slot="checkbox-label"
              >
                <v-chip class="tiny-extra-bold" small label color="success"
                  >Success</v-chip
                >
              </div></apio-checkbox
            >
            <apio-checkbox :value="false" :checked="warning" v-model="warning"
              ><div
                class="event-log-detail-view__checkbox"
                slot="checkbox-label"
              >
                <v-chip class="tiny-extra-bold" small label color="warning"
                  >Warning</v-chip
                >
              </div></apio-checkbox
            >
            <apio-checkbox :value="true" :checked="error" v-model="error"
              ><div
                class="event-log-detail-view__checkbox"
                slot="checkbox-label"
              >
                <v-chip class="tiny-extra-bold" small label color="error"
                  >Error</v-chip
                >
              </div></apio-checkbox
            >
          </div>
          <div
            v-if="dataLoadingError && loaded"
            class="pa-4 pt-0"
          >
            Error loading data
          </div>
          <div
            v-else-if="!loaded"
            class="pa-4 pt-0"
          >
            <ContentLoader viewBox="0 0 100 100">
              <rect x="0" y="0" rx="3" ry="3" width="250" height="10" />
              <rect x="20" y="20" rx="3" ry="3" width="220" height="10" />
              <rect x="20" y="40" rx="3" ry="3" width="170" height="10" />
              <rect x="0" y="60" rx="3" ry="3" width="250" height="10" />
              <rect x="20" y="80" rx="3" ry="3" width="200" height="10" />
              <rect x="20" y="100" rx="3" ry="3" width="80" height="10" />
            </ContentLoader>
          </div>
          <div v-else-if="loaded && eventLogSelectedEvent.all.length > 0">
            <div v-for="(step, id) in steps" :key="id">
              <div class="event-log-detail-view__step--header p1-extra-bold">
                <img v-if="id > 0" :src="`/img/icons/step_${step.type}.svg`" class="event-log-detail-view__step--header--icon">
                <img v-else-if="id === 0" :src="`/img/icons/input_${step.type}.svg`" class="event-log-detail-view__step--header--icon">
                {{ step.label }}
              </div>
              <div class="event-log-detail-view__step--row">
                <span class="pa-4 small-extra-bold">Status</span>
                <events-status-tile
                  v-if="step"
                  class="event-log-detail-view__step--row--tile"
                  :status="step.status"
                />
              </div>
              <div class="py-2 pl-4 event-log-detail-view__step--row">
                <span class="small-extra-bold">Message</span>
                <span class="small mr-4">{{ step.label }}</span>
              </div>
              <div
                class="event-log-detail-view__step--last-row"
              >
                <span
                  @click="showIOView(step, i, step.data[i], id)"
                  v-for="(item, i) in step.data"
                  :key="i"
                  class="event-log-detail-view__pill"
                  :class="{'event-log-detail-view__errorpill': i.toLowerCase().includes('error')}"
                >
                  <apio-icon
                    name="nav-layers"
                    size="16"
                    lightModeColour="white"
                    darkModeColour="white"
                  />
                  <div style="margin: 0 auto;" class="text-uppercase extra-tiny-extra-bold white--text">
                    {{ i }}
                  </div></span
                >
              </div>
            </div>
          </div>

          <div class="pa-4 pt-0" v-if="loaded && eventLogSelectedEvent.all.length > 0 && eventSteps.length === 0">
            No data for these filter options
          </div>

          <div class="pa-4 pt-0" v-if="loaded && eventLogSelectedEvent.all.length === 0">
            No data for this event
          </div>
        </div>
      </div>
    </portal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import request from '@/API/';
import * as clipboard from "clipboard-polyfill/text";
import { pickBy, keys } from "lodash"; //The _.pickBy() method is used to return a copy of the object that composed of the object properties predicate returns truthy for.
import debounce from "lodash.debounce";

export default {
  name: "EventLogDetailView",
  props: {
    show: {
      type: Boolean,
    },
  },
  components: {
    EventsStatusTile: () => import("./EventsStatusTile"),
    EventLogDetailViewIO: () => import("./EventLogDetailViewIO"),
  },
  computed: {
    ...mapState({
      eventLogDetailViewState: (state) => state.mode.eventLogDetailViewState,
      eventLogSelectedEvent: (state) => state.events.eventLogSelectedEvent,
      eventsLogFilterOptions: (state) => state.events.eventsLogFilterOptions,
      apps: (state) => state.apps.apps,
    }),
    showDialog: {
      get: function () {
        return this.$store.state.mode.eventLogDetailViewState;
      },
      set: function (value) {
        this.$store.commit("set", ["eventLogDetailViewState", value]);
      },
    },
    getClientHashByAppID() {
      const x = this.apps.filter((item) => {
        return item.appID === this.eventsLogFilterOptions.selectedApp;
      });
      if (x && x[0]) return x[0].clientHash;
      return null;
    },
    navigationDrawerWidth() {
      return this.$vuetify.breakpoint.width <= 600
        ? this.$vuetify.breakpoint.width
        : 600;
    },
    steps() {
      return this.eventSteps;
    },
    isDarkMode() {
      return this.$store.state.mode.darkMode;
    },
    backgroundColour() {
      return this.isDarkMode
        ? "event-log-detail-view--dark"
        : "event-log-detail-view--light";
    },
  },
  mounted () {
    window.addEventListener('keydown', this.keyDownHandler);
  },
  unmounted () {
    window.removeEventListener('keydown', this.keyDownHandler);
  },
  watch: {
    eventLogDetailViewState(newValue) {
      if (newValue) this.loadDetails();
    },
    error: function () {
      this.filterEventsSteps();
    },
    warning: function () {
      this.filterEventsSteps();
    },
    success: function () {
      this.filterEventsSteps();
    },
  },
  data() {
    return {
      eventLogDetailViewIO: false,
      error: true,
      warning: false,
      success: true,
      key: Math.random(),
      selectedStep: {
        data: null,
        ref: null,
        label: null,
        name: null,
        kind: null,
      },
      eventSteps: [],
      loaded: false,
      dataLoadingError: false,
      q: '',
    };
  },
  methods: {
    keyDownHandler () {
      this.$store.commit("set", ["eventLogDetailViewIO", false]);
      this.$root.$emit('set-modal-open', false);
    },
    async copyToClipboard(val) {
      const vm = this;
      await clipboard.writeText(val).then(
        function () {
          vm.snackBarText = "Copied to clipboard";
          vm.snackBarStatus = "success";
          vm.snackbar = true;
        },
        function () {
          vm.snackBarText = "Could not copy value to the clipboard";
          vm.snackBarStatus = "error";
          vm.snackbar = true;
        }
      );
    },
    filterEventsSteps() {
      const steps = this.eventLogSelectedEvent.all;
      if (steps === undefined || steps === null) return;
      this.statuses = {
        error: this.error,
        success: this.success,
        warning: this.warning,
      };
      const filtered = pickBy(this.statuses);
      const selectedFilterStatuses = keys(filtered);
      var filteredSteps = steps.filter((step) =>
        selectedFilterStatuses.includes(step.status)
      );
      filteredSteps.forEach( item => {
        if (item.Label != undefined) {
          item.label = item.Label;
        }
        if (item.Type != undefined) {
          item.type = item.Type;
        }
      });
      this.eventSteps = filteredSteps;
      this.key = Math.random();
    },
    showIOView(step, name, data, i) {
      if (data.url != undefined) {
        request.get(data.url).then(res => {
          data = res.data;
          this.realShowView(step, name, data, i);
        }).catch(error => {
          data = {value: error, _type: "string"};
          this.realShowView(step, name, data, i);
        });
      } else {
        this.realShowView(step, name, data, i);
      }
    },
    realShowView(step, name, data, i) {
      this.selectedStep.data = data;
      this.selectedStep.ref = this.eventLogSelectedEvent.ref;
      this.selectedStep.label = step.label;
      this.selectedStep.type = step.type;
      this.selectedStep.name = name;
      this.selectedStep.kind = i==0?'input':'step';
      this.$root.$emit('set-modal-open', true);
      this.eventLogDetailViewIO = true;
    },
    loadDetails: debounce( async function() {
      this.key = Math.random();
      this.filterEventsSteps();
      this.loaded = false;
      this.dataLoadingError = false;
      this.eventLogSelectedEvent.all = []
      await request
        .get(
          `/data/list?c=${this.eventLogSelectedEvent.clientHash}&a=${
            this.eventLogSelectedEvent.appHash ||
            this.eventsLogFilterOptions.selectedApp
          }&i=${this.eventLogSelectedEvent.interfaceHash}&e=${
            this.eventLogSelectedEvent.ref
          }&q=${this.q}`,
          {
            timeout: 5000,
          }
        )
        .then((res) => {
          this.eventLogSelectedEvent.all = res.data || [];
          this.key = Math.random();
          this.filterEventsSteps();
          this.loaded = true;

        })
        .catch((e) => {
          console.log(e);
          this.eventLogSelectedEvent.all = [];
          this.key = Math.random();
          this.dataLoadingError = true;
          this.loaded = true;
        })
    }, 1000),
  },
};
</script>

<style lang="scss" scoped>
.smalltext {
  font-size: 10px;
  white-space: pre-wrap;
}
.event-log-detail-view {
  &--light {
    background: #fff;
    color: var(--apio-shade-2);
  }

  &--dark {
    background: var(--apio-shade-1);
    color: #fff;
  }

  min-width: 521px;
  height: calc(100vh);
  position: fixed;
  top: 0;
  right: 0;
  z-index: 12;
  box-shadow: -10px 0px 10px 1px #aaaaaa;

  @media screen and (max-width: 521px) {
    min-width: 100%;
  }

  height: 100%;
  &__checkbox {
    width: 100px;
  }

  &__pill {
    align-items: center;
    background-color: var(--apio-purple);
    border-radius: 16px;
    cursor: pointer;
    display: flex;
    height: 24px;
    justify-content: space-between;
    margin: 0 4px 4px;
    min-width: 64px;
    padding: 4px;
    width: fit-content;
  }

  &__errorpill {
    align-items: center;
    background-color: var(--apio-magenta);
  }

  &__statuses {
    display: flex;
    padding: 8px 16px 16px;
    @media screen and (max-width: 400px) {
      flex-flow: row wrap;
    }
    &--title {
      padding: 16px 0 0 16px;
    }
  }

  &__step {
    &--header {
      align-items: center;
      background: var(--apio-shade-5);
      color: #6a6c73;
      display: flex;
      height: 48px;
      padding: 4px 0 4px 16px;
      width: 100%;

      &--icon {
        background-color: var(--apio-purple);
        border-radius: 5px;
        height: 32px;
        margin-right: 16px;
        width: 32px;
      }
    }
    &--last-row {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      max-height: 540px;
      justify-content: flex-end;
      overflow-x: hidden;
      overflow-y: auto;
      padding: 8px 16px;
    }
    &--row {
      border-bottom: 1px solid var(--apio-shade-5);
      display: flex;
      justify-content: space-between;

      &--tile {
        height: 48px !important;
        max-width: 120px !important;
      }
    }
  }

  &__inner {
    top: 106px;
    overflow-y: scroll;
    position: absolute;
    height: calc(100% - 106px);
    overflow: auto;
    width: 100%;
  }

  &__header {
    $header-height: 106px;
    $header-padding: 16px;
    $header-bottom-padding: 16px;
    background: var(--apio-shade-3);
    height: $header-height;
    padding: $header-padding;
    position: fixed;

    width: 100%;

    &--close-button {
      position: fixed;
      top: 16px;
      right: 16px;
    }

    &--id {
      $header-id-padding: $header-padding * 2;
      width: calc(490px - (#{$header-id-padding}));
      position: absolute;
      top: calc(
        (#{$header-height} - (#{$header-padding - $header-bottom-padding})) / 2
      );
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
